import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useStoryBlokStore = defineStore('storyBlock', () => {

  const storyBlokData = ref();


  const body = computed(() => {
    if(storyBlokData.value === undefined) return undefined;
    return storyBlokData.value.story.content.body;
  });

  const steps = computed(() => {
    return getDataForComponent('steps');
  });

  const metadata = computed(() => {
    if(body.value === undefined) return undefined;
    return getDataForComponent('metadata');
  });

  function setStoryBlokData(data) {
    storyBlokData.value = data;
  }

  function getDataForComponent (componentName) {
    if(body.value === undefined) return undefined;

    return body.value.find(bodyElements => bodyElements.component === componentName);
  }

  return { setStoryBlokData, storyBlokData, steps, body, metadata}
})
